module.exports = __webpack_public_path__ + "videos/6b5f51f225473ef557c3725661856d93.mp4";